import { getCookies } from 'Modules/cookies';
import { ajaxGet } from 'Modules/ajax';
import { getCurrentUserFromGlobal } from 'lib/current-user';

import { COOKIE_NAME, API_LIVE_CONTENT_URL, PUBLIC_API_KEY } from '../constants/blueshift';

function getFromBlueshift(slot) {
  const cookie = getCookies()[COOKIE_NAME];
  const { email } = getCurrentUserFromGlobal();

  let liveContentUrl = `${API_LIVE_CONTENT_URL}?slot=${slot}&x=${PUBLIC_API_KEY}`;

  if (cookie) {
    liveContentUrl += `&cookie=${cookie.replace(/"/g, '')}`;
  }

  if (email) {
    liveContentUrl += `&email=${email}`;
  }

  return ajaxGet(liveContentUrl, { swallowError: true, headerXRequestedWith: false });
}

/**
 * @typedef {Object} BlueshiftLiveContent
 * @description Object returned by the blueshift API.
 * @property {bool} data.show
 * @property {string} data.content.body
 * @property {string} data.content.button
 * @property {string} data.content.link
 * @property {string} data.content.matchingUrl
 * @property {bool} data.content.isMatchingUrlRegExp
 * @property {string} data.content.dataEvent.type
 * @property {string} data.content.dataEvent.category
 * @property {string} data.content.dataEvent.action
 * @property {string} data.content.dataEvent.label
 * @property {string} data.tracking.impression_url
 * @property {string} data.tracking.click_url
 */

export default getFromBlueshift;
